import { ChangeEvent, useCallback } from 'react'

import PlainCheckbox from 'app/common/ui-next/plain-checkbox'
import useCallbackRef from 'app/common/hooks/useCallbackRef'

import styles from './Status.module.scss'
import { EncashmentsStatusType, encashmentsStatusTitle } from 'app/dataTypes/reports/data'


type Props = {
  status: EncashmentsStatusType | null
  schoolTitle: string
  buildingTitle: string
  salePointTitle: string
  salePointId: string
  selectionMode: boolean
  selected: boolean
  onClick: (salePointId: string, checked: boolean) => void
}

export const Status = ({
  schoolTitle,
  buildingTitle,
  salePointTitle,
  status,
  salePointId,
  selectionMode,
  selected,
  onClick,
}: Props) => {
  const statusDescription = encashmentsStatusTitle[status ?? '']

  const onClickRef = useCallbackRef(onClick)

  const handleClick = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const { checked, value } = e.currentTarget
    onClickRef.current?.(value, checked)
  }, [onClickRef])

  return (
    <div className={styles.root}>
      {selectionMode
        ? <PlainCheckbox
          id={salePointId}
          className={styles.checkbox}
          label={schoolTitle}
          value={salePointId}
          checked={selected}
          onChange={handleClick}
          hideLabel
        />
        : <div className={styles.indicator}>
          <div className={styles.circle} />
        </div>}

      <label className={styles.title} htmlFor={salePointId}>{schoolTitle}</label>

      <div className={styles.info}>
        <div>{`(${buildingTitle},`}</div>
        <div>{`${salePointTitle})`}</div>
      </div>

      <div className={styles.status}>
        <div>{statusDescription}</div>
      </div>
    </div>
  )
}
